// import red from '@mui/material/colors/red'
// import green from '@mui/material/colors/green'
// import pink from '@mui/material/colors/pink'

const themes = [
  {
    id: "default",
    source: {
      typography: {
        fontSize: 12,
        htmlFontSize: 14,
      },
      spacing: 4,
      palette: {
        // Define your primary and secondary colors here
        primary: {
          main: "#368727", // This will be your main primary color
          light: "#5da44f",
          dark: "#265e1d",
          contrastText: "#fff", // A color to be used on top of the main color
        },
        secondary: {
          main: "#f50057", // Example secondary color
        },

        footercolor: {
          main: "#ebf5ee",
          contrastText: "#112417",
          // main: '#ccd4d9',
          // contrastText: '#373b3c', // A color to be used on top of the main color
        },
        bannercolor: {
          main: "#327c23",
          contrastText: "#fff",
        },
        success: {
          main: "#166534",
          light: "#e8f5e9",
          dark: "#14532d",
          contrastText: "#fff",
        },
        // Your custom colors go here
        warningAlert: {
          main: "#ff9800",
          light: "#ffb74d",
          dark: "#e65100",
        },
        infoAlert: {
          main: "#2196f3",
          light: "#64b5f6",
          dark: "#1565c0",
        },
        decisionAlert: {
          main: "#4caf50",
          light: "#81c784",
          dark: "#388e3c",
        },
        // High-contrast neutral palette for readable borders and cards
        grey: {
          50: "#f8fafc",
          100: "#f1f5f9",
          200: "#cbd5e1", // Replaces faint #eeeeee with high-contrast slate #cbd5e1
          300: "#94a3b8",
          400: "#64748b",
          500: "#475569",
          600: "#334155",
          700: "#1e293b",
          800: "#0f172a",
          900: "#020617",
        },
        divider: "#cbd5e1",
      }, //palette
      components: {
        // Your component-level overrides go here

        MuiPaper: {
          styleOverrides: {
            root: {
              // Ensure outlined papers have crisp, readable 1.5px border
              "&.MuiPaper-outlined": {
                borderColor: "#cbd5e1",
                borderWidth: "1.5px",
              },
            },
          },
        },

        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              borderColor: "#cbd5e1",
              borderWidth: "1px",
            },
            root: {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#94a3b8",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#368727",
                borderWidth: "1.5px",
              },
            },
          },
        },

        MuiDivider: {
          styleOverrides: {
            root: {
              borderColor: "#cbd5e1",
            },
          },
        },

        MuiDialog: {
          styleOverrides: {
            paper: {
              borderRadius: "16px", // This creates the rounded corners
            },
          },
        },
        // 2. Target the DialogTitle for a color change
        MuiDialogTitle: {
          styleOverrides: {
            root: {
              backgroundColor: "#e3f2fd",
              color: "#1a237e",
            },
          },
        },

        MuiButton: {
          styleOverrides: {
            root: {
              // width: '150px', // Set a fixed width for all buttons
              // You can also add other styles here, like padding or color
              minWidth: '75px',
              padding: "8px 16px",
              fontSize: "0.8rem", // You can still override individual components
              borderRadius: "10px", // Set a high value for a pill-like button
              boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2)", // Add a subtle shadow
            },
          },
          // You can also set default props, like making all buttons have a 'contained' variant
          defaultProps: {
            variant: "contained",
            size: "small", // Use the 'small' size by default for all buttons
          },
        },

        MuiChip: {
          styleOverrides: {
            colorSuccess: {
              backgroundColor: "#e8f5e9",
              color: "#166534",
              border: "1px solid #bbf7d0",
              "& .MuiChip-icon": {
                color: "#166534",
              },
            },
            colorInfo: {
              backgroundColor: "#e0f2fe",
              color: "#0369a1",
              border: "1px solid #bae6fd",
              "& .MuiChip-icon": {
                color: "#0369a1",
              },
            },
            colorWarning: {
              backgroundColor: "#fef3c7",
              color: "#b45309",
              border: "1px solid #fde68a",
              "& .MuiChip-icon": {
                color: "#b45309",
              },
            },
          },
        },
      }, // components
    }, // source
  }, // id
];

export default themes;

/* 
    darker
 

Main: #368727

Shade 1: #327c23

Shade 2: #2e701f

Shade 3: #29651c

Shade 4: #255a19

Shade 5: #214f15

    ligher

Main: #368727

Shade 1: #5da44f

Shade 2: #72b069

Shade 3: #87bd84

Shade 4: #9dd0a0

Shade 5: #b2d6bc


    */
